import { convertNumberToWords } from "@/utils/text";
import NumericUtils from "@/utils/numeric";
import { PRODUCT_TYPE } from "@/app-constant";

const toString = (number, thousandsSeparator, decimalPlaces) =>
  NumericUtils.toString(number, thousandsSeparator, decimalPlaces);
const formatCurrency = number => NumericUtils.formatNumber(number);
const formatAmount = number => NumericUtils.formatNumber(number, "currency");
const formatAmountAsNumber = (number, decimalPlaces) =>
  NumericUtils.formatAmountAsNumber(number, decimalPlaces);

const getListEnum = listEnum =>
  listEnum || JSON.parse(localStorage.getItem("list-enum"));
const getSellerSettings = sellerSettingList =>
  sellerSettingList || JSON.parse(localStorage.getItem("seller-setting-list"));

// const typeOrder = {
//   [PRODUCT_TYPE.PRODUCT]: 1,
//   [PRODUCT_TYPE.DISCOUNT]: 2,
//   [PRODUCT_TYPE.NOTE]: 3,
// };

const makeAroundFn = (currencyCode = "VND", sellerSettingList) => {
  sellerSettingList = getSellerSettings(sellerSettingList);
  return (key = "", type = "on_detail_invoice__settings") => {
    let configKey = key;
    if (!key || !sellerSettingList) return 0;
    if (type !== "qty_rate__settings" && currencyCode !== "VND") {
      configKey = `${key}__FOREIGN`;
    }

    const settingsOfType = sellerSettingList[type] || [];
    const matchedSetting = settingsOfType.find(s => s.key === configKey);

    return matchedSetting && typeof matchedSetting.num_val === "number"
      ? matchedSetting.num_val
      : 0;
  };
};

const toStringWithSettingFn = sellerSettingList => {
  sellerSettingList = getSellerSettings(sellerSettingList);
  return number => {
    if (!number || !sellerSettingList) return "0";
    const [decimal, thousands] = sellerSettingList.seprator__settings;
    return toString(number, thousands.text_val, decimal.text_val);
  };
};

export const makeARound = (
  key = "",
  type = "on_detail_invoice__settings",
  currencyCode = "VND",
  sellerSettingList
) => {
  sellerSettingList = getSellerSettings(sellerSettingList);
  if (!key || !sellerSettingList) return 0;

  let configKey = key;
  if (type !== "qty_rate__settings" && currencyCode !== "VND") {
    configKey = `${key}__FOREIGN`;
  }

  const settingsOfType = sellerSettingList[type] || [];
  const matchedSetting = settingsOfType.find(s => s.key === configKey);

  return matchedSetting && typeof matchedSetting.num_val === "number"
    ? matchedSetting.num_val
    : 0;
};

export const toStringWithSetting = (number, sellerSettingList) => {
  sellerSettingList = getSellerSettings(sellerSettingList);
  if (!number || !sellerSettingList) return "0";
  const [decimal, thousands] = sellerSettingList.seprator__settings;
  return toString(number, thousands.text_val, decimal.text_val);
};

export const parseInvoiceContent = content => {
  const fixedInput = content
    // eslint-disable-next-line no-useless-escape
    .replace(/\"/g, '\\"')
    .replace(/\bNone\b/g, '"None"') // Handling None
    .replace(/: ""/g, ": null")
    .replace(/: ''/g, ": null")
    .replace(/'/g, '"')
    .replace(/""/g, '"');

  try {
    return JSON.parse(fixedInput);
  } catch (error) {
    console.log("Error parsing JSON:", error);
    return null;
  }
};

export const parseInvoiceFile = payload => {
  if (payload) {
    const base64Content = payload.replace(/^b'(.+)'$/, (match, p1) => p1);
    const decodedBase64Content = atob(base64Content);
    const parser = new DOMParser();
    const myDocument = parser.parseFromString(decodedBase64Content, "text/xml");
    if (!myDocument.querySelector("parsererror")) {
      return {
        type: "xml",
        content: decodeURIComponent(escape(decodedBase64Content))
      };
    }
    return {
      type: "pdf",
      content: `data:application/pdf;base64,${base64Content}`
    };
  }
  return null;
};

export const getStatisticFromInvoices = (invoices = []) => {
  const { revenue, expense } = invoices.reduce(
    (acc, current) => {
      const amount = parseInt(current.total_amount_without_tax, 0) || 0;
      if (current.kind_of) {
        acc.revenue += amount;
      } else {
        acc.expense += amount;
      }
      return acc;
    },
    { revenue: 0, expense: 0 }
  );
  return {
    revenue: formatAmount(revenue),
    expense: formatAmount(expense),
    benefit: formatAmount(revenue - expense)
  };
};

export const handleDataBuyer = (invoice = {}) => {
  const buyerTaxCode =
    invoice.buyer_taxcode && typeof invoice.buyer_taxcode === "object"
      ? invoice.buyer_taxcode.company_TaxCode
      : invoice.buyer_taxcode;
  return {
    buyer_name: invoice.buyer_name,
    buyer_code: "",
    buyer_legal_name: invoice.buyer_legal_name,
    buyer_tax_code: buyerTaxCode,
    buyer_address_line: invoice.buyer_address,
    buyer_phone_number: invoice.buyer_phone_number,
    buyer_email: invoice.buyer_email,
    buyer_metadata: { test: "test" },
    buyer_id_no: invoice.buyer_id_no,
    mdvqhnsach: invoice.mdvqhnsach,
    buyer_passport_no: invoice.buyer_passport_no,
    buyer_type: invoice.buyer_type
  };
};

export const formatTotals = (
  totals = {
    total_amount_without_tax: 0,
    total_amount_with_tax: 0,
    total_tax_mount: 0
  },
  currencyCode = "VND",
  listEnum
) => {
  listEnum = getListEnum(listEnum);
  let currency = "đồng";
  let isAdjust = false;

  if (listEnum && listEnum.CurrencyCodeEnum) {
    const foundCurrency = listEnum.CurrencyCodeEnum.find(
      x => x.id === currencyCode
    );
    if (foundCurrency && foundCurrency.label) {
      currency = foundCurrency.label.toUpperCase();
    }
  }

  const makeAround = makeAroundFn(currencyCode);

  const roundSettings = {
    // Chi tiết hóa đơn (on_detail_invoice__settings)
    SUB_TOTAL: makeAround("SUB_TOTAL", "on_detail_invoice__settings"),
    TAX_MONEY: makeAround("TAX_MONEY", "on_detail_invoice__settings"),

    // Tổng hóa đơn (on_invoice__settings)
    TOTAL_MONEY: makeAround("TOTAL_MONEY", "on_invoice__settings"), // tổng trước thuế
    TAX_GTGT_MONEY: makeAround("TAX_GTGT_MONEY", "on_invoice__settings"),
    CHIET_KHAU_MONEY: makeAround("CHIET_KHAU_MONEY", "on_invoice__settings"),
    SUM_LOADS_MONEY: makeAround("SUM_LOADS_MONEY", "on_invoice__settings") // tổng thanh toán (sau thuế)
  };

  totals.total_amount_without_tax = formatAmountAsNumber(
    totals.total_amount_without_tax,
    roundSettings.TOTAL_MONEY
  );
  totals.total_tax_mount = formatAmountAsNumber(
    totals.total_tax_mount,
    roundSettings.TAX_GTGT_MONEY
  );
  totals.total_amount_with_tax = formatAmountAsNumber(
    totals.total_amount_with_tax,
    roundSettings.SUM_LOADS_MONEY
  );
  const total_amount_with_tax_in_words = convertNumberToWords(
    Math.trunc(totals.total_amount_with_tax),
    currency,
    isAdjust
  );

  return { ...totals, total_amount_with_tax_in_words };
};
export const normalizeLineTotals = item => {
  const hasProductDesc = item.PRODUCT_DESC && item.PRODUCT_DESC.length > 0;

  if (!hasProductDesc) {
    return {
      subTotalInFloat: 0,
      taxMoneyInFloat: 0,
      maxTotals: 0,
      rate: 0
    };
  }

  let matchVAT = null;
  if (typeof item.PRODUCT_VAT_RATE === "string") {
    matchVAT = item.PRODUCT_VAT_RATE.match(/(\d+)%/);
  }

  let rate = "NONE";
  if (item.PRODUCT_VAT_RATE) {
    rate = matchVAT ? matchVAT[1] : item.PRODUCT_VAT_RATE;
  }

  const taxExempt = !rate || rate === "NONE";

  const subTotalInFloat = item.PRODUCT_AMOUNT
    ? parseFloat(item.PRODUCT_AMOUNT)
    : 0;
  const totalInFloat = item.PRODUCT_TOTAL_AMOUNT
    ? parseFloat(item.PRODUCT_TOTAL_AMOUNT)
    : 0;
  const taxMoneyInFloat = item.PRODUCT_TAX_AMOUNT
    ? parseFloat(item.PRODUCT_TAX_AMOUNT)
    : subTotalInFloat * (taxExempt ? 0 : parseFloat(rate) / 100);
  const maxTotals = Math.max(totalInFloat, taxMoneyInFloat + subTotalInFloat);

  return { subTotalInFloat, taxMoneyInFloat, maxTotals, rate };
};

export const calculateTotalsFromInvoice = products => {
  return products.reduce(
    (acc, item) => {
      const {
        subTotalInFloat,
        taxMoneyInFloat,
        maxTotals,
        rate
      } = normalizeLineTotals(item);

      acc = {
        total_amount_without_tax:
          acc.total_amount_without_tax + subTotalInFloat,
        total_tax_mount: acc.total_tax_mount + taxMoneyInFloat,
        total_amount_with_tax: acc.total_amount_with_tax + maxTotals
      };

      return acc;
    },
    {
      total_amount_without_tax: 0,
      total_tax_mount: 0,
      total_amount_with_tax: 0
    }
  );
};

export const handleDataInvoice = (invoice = {}, currencyCode) => {
  const isVatInvoice = invoice.invoice_type === "1";

  const makeAround = makeAroundFn(currencyCode);
  const toStringWithSetting = toStringWithSettingFn(currencyCode);

  const roundSettings = {
    QUANTITY: makeAround("QUANTITY", "qty_rate__settings"),
    UNIT_PRICE: makeAround("UNIT_PRICE", "on_detail_invoice__settings"),
    SUB_TOTAL: makeAround("SUB_TOTAL", "on_detail_invoice__settings"),
    TAX_MONEY: makeAround("TAX_MONEY", "on_detail_invoice__settings"),
    SUM_LOADS_MONEY: makeAround("SUM_LOADS_MONEY", "on_invoice__settings")
  };

  const calculateRate = line => {
    if (line.rate === "KHAC") return parseFloat(line.custom_tax_rate);
    if (["KKKNT", "NONE"].includes(line.rate)) return null;
    return parseFloat(line.rate);
  };

  // handle products
  const formatProductLine = l => {
    if (l.type === PRODUCT_TYPE.DECREE && !l.total) {
      return null;
    }

    const name =
      l.type === PRODUCT_TYPE.DECREE
        ? `Đã giảm ${formatAmountAsNumber(
            parseFloat(l.total),
            roundSettings.SUM_LOADS_MONEY
          )} đồng tương ứng 20% mức tỷ lệ % để tính thuế giá trị gia tăng theo Nghị quyết số 204/2025/QH15`
        : l.name;

    const formattedQuantity = formatAmountAsNumber(
      parseFloat(l.quantity),
      roundSettings.QUANTITY
    );
    const formattedPrice = l.price
      ? formatAmountAsNumber(parseFloat(l.price), roundSettings.UNIT_PRICE)
      : null;
    const formattedSubtotal = l.subtotal
      ? formatAmountAsNumber(parseFloat(l.subtotal), roundSettings.SUB_TOTAL)
      : 0;
    const formattedTaxMoney = l.tax_money
      ? formatAmountAsNumber(parseFloat(l.tax_money), roundSettings.TAX_MONEY)
      : 0;
    const formattedTotal = l.total
      ? formatAmountAsNumber(parseFloat(l.total), roundSettings.SUM_LOADS_MONEY)
      : 0;

    return {
      name,
      code: l.code,
      unit: l.unit || null,
      type: l.type === PRODUCT_TYPE.DECREE ? PRODUCT_TYPE.NOTE : l.type,
      quantity: formattedQuantity || null,
      price: formattedPrice,
      rate: isVatInvoice ? calculateRate(l) : null,
      rate_name: l.rate === "KKKNT" ? "KKKNT" : null,
      subtotal: formattedSubtotal,
      tax_money: formattedTaxMoney,
      total: formattedTotal,
      method: l.method || null,
      make_around_meta: {
        price: l.price ? toStringWithSetting(formattedPrice) : null,
        quantity: toStringWithSetting(formattedQuantity),
        rate: isVatInvoice ? calculateRate(l) : null,
        subtotal: l.subtotal ? toStringWithSetting(formattedSubtotal) : 0,
        tax_money: isVatInvoice ? toStringWithSetting(formattedTaxMoney) : null,
        total: l.total ? toStringWithSetting(formattedTotal) : 0
      }
    };
  };

  const data = {
    id: `${invoice.id}`,
    selfcontrol_values: false,
    file_path: invoice.file_path,
    note_change: invoice.note_change,
    cancel_date: invoice.cancel_date,
    reason_change: invoice.reason_change,
    currency_code: invoice.currency_code,
    agreement_date: invoice.agreement_date,
    payment_method: invoice.payment_method,

    invoice_common_code: invoice.invoice_common_code,
    invoice_template_code: invoice.invoice_template_code,
    invoice_type: `${invoice.invoice_type}`,
    invoice_number: invoice.invoice_number,
    invoice_issued_date: new Date(),

    to_day: new Date(),
    status: invoice.status,
    code_tax_approved: invoice.code_tax_approved,
    // Sẽ tùy chỉnh ngày lập hóa đơn
    // invoice_issued_date: new Date(invoice.invoice_issued_date),
    date_create_original: invoice.date_create_original,
    seller_template_announcement: invoice.seller_template_announcement,
    buyer_data: handleDataBuyer(invoice),
    lines: invoice.lines.map(formatProductLine).filter(Boolean),
    ...formatTotals(
      {
        total_amount_with_tax: invoice.total_amount_with_tax || 0,
        total_amount_without_tax: invoice.total_amount_without_tax || 0,
        total_tax_mount: invoice.total_tax_mount || 0
      },
      invoice.currency_code
    )
  };

  if (data.currency_code !== "VND") {
    data.foreign_rate = parseFloat(invoice.foreign_rate);
  }

  // handle signature status
  if (invoice.ca_type && invoice.ca_type === "HSM") {
    data.ca_type = invoice.ca_type;
    data.ca_id = invoice.ca_id;
    data.is_publish_now = true;
  } else {
    data.is_preparing_for_usb = true;
    data.is_publish_now = false;
  }

  // handle preview
  if (invoice.is_draf_preview) {
    data.is_draf_preview = true;
  }

  // handle include info
  if (invoice.include_info) {
    data.data_plus_for_phieu_xkvc = {
      NBan_LDDNBo: invoice.NBan_LDDNBo,
      NBan_PTVChuyen: invoice.NBan_PTVChuyen,
      NBan_HDSo: invoice.NBan_HDSo,
      NBan_DChi: invoice.NBan_DChi,
      NBan_TNVChuyen: invoice.NBan_TNVChuyen,
      NBan_HVTNXHang: invoice.NBan_HVTNXHang
    };
  }
  // handle self control
  data.selfcontrol_values = true;
  return data;
};

export const handleDataInvoiceChange = invoice => {
  const {
    change_data: changeData,
    changed_invoice_data: changedInvoiceData,
    currency_code: currencyCode
  } = invoice;
  return {
    change_data: handleDataInvoice(changeData, currencyCode),
    changed_invoice_data: handleDataInvoice(changedInvoiceData, currencyCode)
  };
};

/**
 * Gom các trường cần truyền tường minh vào props.item của actions-invoice-modal.
 * Tránh dùng `...res` đơn thuần vì Vue 2 reactive object có thể bỏ sót property
 * khi spread (đặc biệt là `lines_fk` và `content`).
 */
export const buildActionInvoiceItem = (res = {}) => ({
  content: res.content || null,
  lines_fk: Array.isArray(res.lines_fk) ? res.lines_fk : [],
  status: res.status,
  buyer_obj: res.buyer_obj,
  foreign_rate: res.foreign_rate,
  tranfered_pdf: res.tranfered_pdf,
  mail_histories: res.mail_histories,
  code_tax_approved: res.code_tax_approved,
  invoice_common_code: res.invoice_common_code,
  template_package_order: res.template_package_order_fk,
  data_plus_for_phieu_xkvc: res.data_plus_for_phieu_xkvc
});

export default {
  makeARound,
  parseInvoiceContent,
  parseInvoiceFile,
  getStatisticFromInvoices,
  handleDataBuyer,
  calculateTotalsFromInvoice,
  normalizeLineTotals,
  handleDataInvoice,
  handleDataInvoiceChange,
  buildActionInvoiceItem,
  formatAmountAsNumber: NumericUtils.formatAmountAsNumber
};



// WEBPACK FOOTER //
// ./src/utils/invoice.js